import Component from 'formiojs/components/_classes/component/Component';
import { getFormPath } from './form-path-locator/form-path-locator';
import { getAppType } from './form-path-utils';
 
export function getLoanApplicationType(component: Component) {
    let formPath = getFormPath(component);

    return getAppType(formPath);
}